import { useEffect, useState } from "react";
import { Grid, Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, FormGroup, FormControlLabel, Checkbox, CircularProgress, Box, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import { useDispatch, useSelector } from "react-redux";
import { checkApiStatus } from "../../../../utils";
import { addOperatingRegionEscalationApi, editOperatingRegionEscalationApi } from "../apiServices";
import { globalPostService, globalPutService } from "../../../../utils/globalApiServices";
import { AttachementsUpload } from "../../../../shared_elements/components";
import { regexConstants } from '../../../../constants/regEx';
import { useParams } from "react-router-dom";
import { setFileUploadDetails } from "../../../../shared_elements/actions";
import { trackActivity } from "../../../../utils/mixpanel";
import { formatBytes } from "../../../../utils/fileUpload";
import LessMoreTextFieldComp from "../../../../shared_elements/components/LessMoreTextFieldComp";

const RegionCRU = ({ addEditRegion, modeType, fileUpload,  getResponseBack, onToggleModal, onOpenAttachments }) => {
  const dispatch = useDispatch()
  const params = useParams()
  const { storageDetails } = useSelector((state) => state.leases);
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setLoading] = useState(false);
  const [data, setData] = useState(addEditRegion?.data);
  const [error, setError] = useState({});
  const [attachments, setAttachments] = useState([]);

  useEffect(() => {
    if (addEditRegion?.data) {
      setData({
        ...addEditRegion.data,
        // escalation_percentage: formatEscalationPercentage(addEditRegion.data.escalation_percentage),
      });
    }
  }, [addEditRegion?.data]);

  // const formatEscalationPercentage = (value) => {
  //   if (value === null || value === undefined || value === '') return '';
  //   const num = Number(value);
  //   if (isNaN(num)) return '';
  //   return num.toFixed(1);
  // };

  const onRestErrorKey = (key) => {
    setError((prev) => ({ ...prev, [key]: '' }));
  };

  const onFieldChange = (key, value) => {
    setData({ ...data, [key]: value });
    setError((prev) => ({ ...prev, [key]: '' }));
  };

  const handleFileChange = (files) => {
    setAttachments(files);
    dispatch(setFileUploadDetails({attachments:files}))
    
  };

  const onAddEditEscRegion = () => {
    const validationInputs = {
      name: data?.name ? "" : "Please enter Region Name",
      escalation_percentage: data?.escalation_percentage === "" || data?.escalation_percentage === null || data?.escalation_percentage === undefined ? "Please enter Escalation Percentage*" : "",
    };
    if (data?.utilization_created && !data?.status) {
      enqueueSnackbar('This record is associated with Utilization and cannot be disabled', { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
      return;
    }
    if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === ""; })) {
      setLoading(true);
      let payload = {
        ...data,
        escalation_percentage: data.escalation_percentage ?? 0,
        status: data?.status ? 1 : 0,
      };

      if (data.id) {
        globalPutService(editOperatingRegionEscalationApi({ ...params, slug: data?.slug }), payload).then(async (response) => {
          if (checkApiStatus(response)) {
            if (attachments?.length) {
              fileUpload(data?.slug,'updated')
            }
            enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" } });
            onToggleModal()
            getResponseBack();
            setLoading(false);
            trackActivity('Item Edited', { page_title: `Edit Operating Region Esc`, success_msg: response?.data?.message, item_id: data?.id, payload: data, response: response?.data })
          } else {
            setLoading(false);
            enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
            trackActivity('Item Edited', { page_title: `Edit Operating Region Esc`, error_msg: response?.data?.message, item_id: data?.id, payload: data, response: response?.data })
          }
        });
      } else {
        globalPostService(addOperatingRegionEscalationApi(params), payload).then(async (response) => {
          if (checkApiStatus(response)) {
            if (attachments?.length) {
              fileUpload(response?.data?.data?.slug,'created')
            }
            enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
            onToggleModal()
            getResponseBack();
            setLoading(false);
            trackActivity('Item Added', { page_title: `Add Operating Region Esc`, success_msg: response?.data?.message, item_id: response?.data?.data?.id, payload: data, response: response?.data })
          } else {
            setLoading(false);
            enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
            trackActivity('Item Added', { page_title: `Add Operating Region Esc`, error_msg: response?.data?.message, item_id: null, payload: data, response: response?.data })
          }
        });
      }
    } else {
      setError(validationInputs);
      trackActivity(`Item ${modeType === 'add' ? 'Added' : 'Edited'}`, { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Operating Region Esc`, error_msg: validationInputs, })
    }
  };
  const handleItemClicked = (page_type) => {
    trackActivity('Item Clicked', { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Operating Region Esc`, page_type: page_type, })
  }
  return (
    <>
      <Dialog
        onClose={(event, reason) => { if (reason !== 'backdropClick') { onToggleModal(); } }}
        aria-labelledby="customized-dialog-title"
        className="add-lease-dialog"
        maxWidth="md"
        fullWidth
        open={addEditRegion.modal}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} className='dialog-header'>
          <Typography sx={{ marginLeft: '10px' }}>
            {data?.id ? `${addEditRegion.mode === "view" ? "View" : "Edit"} Operating Region Escalation` : "Add Operating Region Escalation"}
          </Typography>
        </DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid size={{ md: 6, xs: 12 }}>
              <TextField
                disabled={addEditRegion.mode === "view"}
                id="name"
                label="Region Name"
                variant="outlined"
                size="small"
                margin="normal"
                fullWidth
                required
                value={data?.name || ""}
                onChange={(e) => regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("name", e.target.value.trimStart()) : e.preventDefault()}
                onFocus={() => onRestErrorKey("name")}
                error={Boolean(error.name)}
                helperText={error.name || (data?.name?.length > 50 ? "Maximum 50 characters allowed" : "")}
                slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 50 } }}
              />

            </Grid>
            <Grid size={{ md: 6, xs: 12 }}>
              <TextField
                disabled={addEditRegion.mode === "view"}
                id="escalation_percentage"
                label="Escalation Percentage"
                variant="outlined"
                size="small"
                margin="normal"
                value={data?.escalation_percentage}
                fullWidth
                required
                onChange={(e) => { const isValidPercentage = regexConstants.percantageRegExp.test(e.target.value); if (isValidPercentage) { onFieldChange("escalation_percentage", e.target.value); } }}
                onFocus={() => onRestErrorKey("escalation_percentage")}
                error={Boolean(error.escalation_percentage)}
                helperText={error.escalation_percentage}
                slotProps={{ inputLabel: { shrink: true } }}
              />
            </Grid>
            {modeType === 'view' ?
              <Grid item size={{ md: 12, xs: 12 }}>
                <LessMoreTextFieldComp label='Remarks' value={data?.remarks || ""} />
              </Grid>
              : <Grid size={{ md: 12, xs: 12 }}>
                <TextField
                  fullWidth
                  label="Remarks"
                  name="remarks"
                  aria-label="Remarks"
                  value={data?.remarks || ""}
                  multiline
                  rows={3}
                  onChange={(e) => { regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("remarks", e.target.value.trimStart()) : e.preventDefault(); }} 
                  sx={{ '& .MuiInputBase-input': { resize: 'vertical', overflow: 'auto' } }}
                  slotProps={{ inputLabel: { shrink: true } }}
                />
              </Grid>}
            <Grid size={{ md: 12, xs: 12 }}>
              <FormGroup className='disabled-checkbox-wrapper'>
                <Box className="check-item-div" sx={{cursor: modeType === "view" ? 'not-allowed' : 'pointer'}}>
                  <Checkbox sx={{paddingLeft: 0}} checked={data?.status} onChange={(e) => onFieldChange("status", e.target.checked)} disableRipple disabled={addEditRegion.mode === "view"} />
                  <Typography className="check-item-span" fontSize='14px'>Enable Region based Escalation</Typography>
                </Box>
              </FormGroup>
            </Grid>
            <Grid size={{ md: 12, xs: 12 }} sx={{ mt: 3 }}>
              <Box className="responsive-buttons">
                {data?.id && data?.attachments?.length ?
                  <Button onClick={() => { onOpenAttachments(); handleItemClicked('ViewAttachments Button') }} size='small' variant='outlined' color='primary' sx={{ marginBottom: '10px' }}>({addEditRegion?.data?.attachments?.length})Attachment(s)</Button> : null
                }
                <Button className='available-space-btn' disableRipple size='small' variant='outlined' color='primary'>{`Available Space : ${formatBytes(storageDetails?.remaining_storage)}`}</Button>
              </Box>
              {modeType === 'view' ? null : <AttachementsUpload onFileChange={handleFileChange} attachments={data?.attachments} remainingStorage={storageDetails?.remaining_storage} />}
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions className="dialog-action">
          <Button className="cancel-btn" disabled={isLoading} variant="outlined" size="small" onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }}>{modeType === "view" ? "Close" : "Cancel"}</Button>
          {modeType === "view" ? null : <Button variant="contained" size="small" className="btn-primary" onClick={() => { handleItemClicked('Save Button'); onAddEditEscRegion() }}> {isLoading ? <CircularProgress color='inherit' size={25} /> : "SAVE"}</Button>}
        </DialogActions>
      </Dialog>
    </>
  );
};
export default RegionCRU;
